import {
  SELECIONA_MODAL_LOGOUT,
  SELECIONA_MODAL_TABLEAU,
} from "./actionsConstants";

export const setModalTableau = (estadoModal) => {
  return { type: SELECIONA_MODAL_TABLEAU, payload: estadoModal };
};

export const setModalLogout = (estadoModal) => {
  return {
    type: SELECIONA_MODAL_LOGOUT,
    payload: estadoModal,
  };
};
